import { render, staticRenderFns } from "./FRM_glBancos.vue?vue&type=template&id=c16340c2&"
import script from "./FRM_glBancos.vue?vue&type=script&lang=js&"
export * from "./FRM_glBancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports